// extracted by mini-css-extract-plugin
export default {"profileDisplay":"ProfileDisplay-module__profileDisplay"};